export default "__VITE_ASSET__Dqa32iTz__"